/*Padd with leading zeroes the Catalog number of the products*/
function jd_numberPadding(num, size) {
    var s = num+"";
    while (s.length < size) s = "0" + s;
    //return s;
    document.write(s);
}

/*Convert weight from g to oz and print it*/
function jd_g2oz( weight )
{
  document.write( (( weight*0.035274 ).toFixed(2)).toString());
}

/*Convert length from mm to inch and print it*/
function jd_mm2in( length )
{
  document.write( (( length*0.0393701 ).toFixed(2)).toString());
}

/*Convert length from mm to inch and return it*/
function jd_mm2in( length )
{
  return ( (( length*0.0393701 ).toFixed(2)).toString());
}

/*
Parse the dimensions to see if it's one dimensional of multidimensional
based on existing "x" in the string, and convert to imperial system (mm to inches)
*/
function jd_dimensionsAdjust( str ) {
  str = str.replace(/ /g,''); // trim all spaces
  strArray = str.split("x"); // split into array based on "x" letters

  for(var i=0; i<strArray.length; i++)
  {
    document.write(jd_mm2in(strArray[i]));
    if(i<strArray.length-1)
    {
      document.write("x");
    }
  }

}